import React, { useEffect, useState } from 'react';
import { getRaces } from '../api';

export default function RaceSelector({ value, onChange, includePlaceholder = true }) {
    const [races, setRaces] = useState([]);

    useEffect(() => {
        getRaces().then(setRaces);
    }, []);

    return (
        <select className="form-select" value={value || ''} onChange={(e) => onChange && onChange(e.target.value)}>
            {includePlaceholder && <option value="">-- select race --</option>}
            {races.map((r) => <option key={r.id} value={r.id}>{r.name}</option>)}
        </select>
    );
}
